<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">{{ year }} © Flow Sales.</div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
            Design & Develop by <a href="https://flowsales.com.br/" target="_blank" class="text-decoration-underline">FlowSales.com.br</a>
        </div>
    </div>
    </div>
  </div>
</footer>
